let accessToken: string | undefined;

export function getAccessTokenFromMem() {
  return accessToken;
}

export function setAccessTokenInMem(token: string) {
  accessToken = token;
}
